<body>
  <!--bg start-->
  <div class="bg">
    <!--launching soon-->
    <div class="launching-soon text-center">
      <h1 class="ml12">Launching Soon</h1>
    </div>
    <h2 class="linear-wipe text-center">
      NEW REVOLUTIONIZED INTERNET MARKETING SOLUTIONS
    </h2>
    <div class="left-contents">
      <!--  video starts -->
      <div class="video">
        <div class="video_box">
          <video
            controls
            poster="{{ myLinksS3URL }}images/Image0231.png"
            width="100%"
            class="video-js video-size w-100 h-auto"
            preload="auto"
            data-setup="{}"
            controls
            autoplay="true"
            muted
          >
            <source
              src="{{ myLinksS3URL }}videos/Onpassive_launching_page_video2.mp4"
              type="video/mp4"
            />
          </video>
        </div>
      </div>
      <!--  video ends -->
      <p class="contents">
        <span>F</span>eeling as if you have failed to succeed in your life?
        Start life afresh with ONPASSIVE.. A highly advanced platform that is
        meticulously handcrafted with the best marketing strategies and backed
        up by artificial intelligence. If only you can dream it, you can do it.
        And if you can do it.. DO IT TODAY!
      </p>
      <div class="mobile-button text-center">
        <button class="btn">
          <a id="regform1112" name="regform" target="_blank" rel="noopener"
            >Become A Founder</a
          >
        </button>
      </div>
    </div>
    <div class="globe-logo">
      <div class="globe">
        <img
          src="{{ onPassiveBaseUrl }}onpassive(nov6)/images/globe.png"
          alt="globe"
          width="100%"
        />
      </div>
      <!--logo-->
      <div class="logo">
        <img
          src="{{ onPassiveBaseUrl }}onpassive(nov6)/images/logo.png"
          alt="logo"
        /><br />
        <div class="desktop-button">
          <button class="btn">
            <a
              href="/registration/user?reg={{ userId }}"
              name="regform"
              target="_blank"
              rel="noopener"
              >Become A Founder</a
            >
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--bg ends-->
</body>
